import { z } from "zod";
import { dmaParameterKindDtoSchema } from "../dma-parameter-kind";
export const dmaCalculationResultParameterDtoSchema = z.object({
    name: z.string(),
    value: z.number(),
    unit: z.string(),
    rawName: z.string(),
    kind: dmaParameterKindDtoSchema,
});
